const constants = require('@/util/constants')
require('./config')

/**
 * 当前客服实时统计数据
 */
export function getAgentTodayStatistics (successcb, failedcb) {
  axios.get('/api/statistic/agent/today', {
    params: {
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 根据客服uid获取实时统计数据
 */
export function getTodayStatisticsByAgentUid(uid, successcb, failedcb) {
  axios.get('/api/statistic/agent/today/uid', {
    params: {
      'uid': uid,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取全部统计数据
 */
export function getStatistics (successcb, failedcb) {
  axios.get('/api/statistic/all', {
    params: {
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取全部统计数据
 */
export function getStatisticDetails (page, size, successcb, failedcb) {
  axios.get('/api/statistic/detail', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 搜索统计详情
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function filterStatisticDetail (page, size, date, realName, successcb, failedcb) {
  axios.get('/api/statistic/filter', {
    params: {
      'page': page,
      'size': size,
      'date': date,
      'realName': realName,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取会话统计数据
 */
export function getStatisticThread (page, size, successcb, failedcb) {
  axios.get('/api/statistic/thread', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取评价统计数据
 */
export function getStatisticRate (page, size, successcb, failedcb) {
  axios.get('/api/statistic/rate', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
